import { render, staticRenderFns } from "./TutorPanel.vue?vue&type=template&id=08462f79&scoped=true"
import script from "./TutorPanel.vue?vue&type=script&lang=js"
export * from "./TutorPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08462f79",
  null
  
)

export default component.exports